import React, { useState, useRef } from 'react'
import Select from 'react-select'
import { HTTP } from '../../api/resources'
import { DirectUpload } from '@rails/activestorage';
import Flatpickr from 'react-flatpickr'
import DynamicFieldModal from '../Helpers/Modal/Forms/DynamicFieldModal';

function ProjectForm(props) {
    const [project, setProject] = useState(props.project)
    const [projectManagers, setProjectManagers] = useState(props.project_managers)
    const [projectCoordinators, setProjectCoordinators] = useState(props.project_coordinators)
    const [saving, setSaving] = useState(false)
    const [isDirty, setDirty] = useState(false)
    const [selectedPM, setSelectedPM] = useState(null)
    const [fileUploading, setFileUploading] = useState(false)
    const [pC, setPC] = useState(null)
    const [projectImage, setProjectImage] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const [editingField, setEditingField] = useState(null)
    const [editing, setEditing] = useState(false)
    const team = props.team
    let image = null

    let projectManager = props.project_manager
    let coordinator = props.project_coordinator

    const editModal = (field) => {
        setEditingField(field)
        setOpenModal(true)
        setEditing(field.dynamic_value)
    }

    const closeEditModal = (values) => {
        setOpenModal(false)
        setEditing(false)

        const updatedCustomFieldValues = project.custom_field_values.map(customFieldValue => {
            if (customFieldValue.id === editingField.id) {
              return {
                ...customFieldValue,
                dynamic_value: values
              };
            }
            return customFieldValue;
          }
        );

        setProject({
            ...project,
            custom_field_values: updatedCustomFieldValues
          });
    }

    const validate = () => {
        if (project.name == null || project.name.length == 0) {
            Alert.show('notice', `${team.project_title} name is required`)
            return
        }

        if (!props.new) {
            updateProject()
            return
        }

        createNewProject()
    }

    const updateProject = async () => {
        setSaving(true)

        let data = {
            info: {name: project.name, bio: project.bio, disable_public_donor_post: project.disable_public_donor_post},
            project: {custom_field_values: project.custom_field_values}
        }

        if (!projectManager && selectedPM) data.info.project_manager = selectedPM.id
        if (!coordinator && pC) data.info.manager_ids = [pC.id]
        if (projectImage) data.info.cover_image = projectImage

        try {
            await patchRequest(data)
        } catch {
            Alert.show('error', `Could not update ${team.project_title.toLowerCase()}, try again`)
            setSaving(false)
            return
        }


        Alert.show('notice', `${team.project_title} updated successfully`)
        setSaving(false)
        setTimeout(() => window.location = '/pro', 1500)
    }

    const patchRequest = (data) => {
        return HTTP.patch(`/pro/edit/${project.id}`, data)
    }

    const createNewProject = async () => {
        setSaving(true)

        let data = {
            info: {name: project.name, bio: project.bio}
        }

        if (selectedPM) data.info.project_manager = selectedPM.id
        if (pC) data.info.manager_ids = [pC.id]

        try {
            await createRequest(data)
        } catch {
            Alert.show('error', `Could not create ${team.project_title.toLowerCase()}, try again`)
            setSaving(false)
            return
        }


        Alert.show('notice', `${team.project_title} created successfully`)
        setSaving(false)
        setTimeout(() => window.location = '/pro', 1500)
    }

    const createRequest = (data) => {
        return HTTP.post("/pro/new", data)
    }

    const hiddenFileInput = React.useRef(null);

    const handleClick = (event) => {
        hiddenFileInput.current.click();
    }

    const handleChange = (event) => {
        setDirty(true)
        const files = event.target.files;
        // upload only the first file
        uploadFile(files[0])
    }

    const uploadFile = (file) => {
        // Check for .jiff extension
        if (file.name.endsWith('.jfif')) {
            Alert.show('error', '.jiff image is not allowed');
            return;
        }


        setFileUploading(true)
        const upload = new DirectUpload(file, '/api/v1/direct_uploads');
        upload.create((error, blob) => {
          if (error) {
            // Handle the error
            Alert.show("error", "Could not update. Try again.");
            setFileUploading(false)
          } else {
            setTimeout(() => { setFileUploading(false) }, 5000);
            image = blob
            setProjectImage(image.cdn_url)
            Alert.show('notice', 'Image has been added')
          }
        })
       }

       const handleInputChange = (field, newValue) => {
        const updatedCustomFieldValues = project.custom_field_values.map(customFieldValue => {
          if (customFieldValue.name === field.name) {
            return {
              ...customFieldValue,
              value: newValue
            };
          }
          return customFieldValue;
        });

        setProject({
          ...project,
          custom_field_values: updatedCustomFieldValues
        });
      };


  return (
    <div className={props.new ? "cu-change": ""}>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                    <div>
                        {props.new &&<h4 class="card-title">New {team.project_title}</h4>}
                        {!props.new &&<h4 class="card-title">{`${project.name}`}</h4>}
                    </div>

                    <div>
                        <a className="btn btn-outline-danger mr-1" href="/pro">Cancel</a>
                        <button className="btn btn-primary" onClick={validate}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Save
                        </button>
                    </div>
                    </div>
                    {props.new &&
                    <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Name</label>
                            <input type="text" className="form-control" placeholder={`${team.project_title} Name`} id="first_name" value={project.name}
                            onChange={(e) => {
                                let value = e.target.value
                                setProject({...project, name: value})
                                setDirty(true)
                            }}
                            />
                        </div>
                        </div>
                    </div>
                    <div className="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label htmlFor="manager_role">Select {team.project_title} Manager</label>
                            <div className="input-group" id="manager_role">
                            <Select
                                className="form-control select-beneficiaries"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => {
                                    setSelectedPM(type);
                                }}
                                options={projectManagers}
                                getOptionLabel={(option) =>
                                    `${option.first_name} ${option.last_name}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedPM}
                            />
                            </div>
                        </div>
                    </div>
                        <div className="col-md-6">
                        <div class="form-group">
                            <label htmlFor="manager_role">Select {team.project_title} Coodinator</label>
                            <div className="input-group" id="manager_role">
                            <Select
                                className="form-control select-beneficiaries"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => setPC(type)}
                                options={projectCoordinators}
                                getOptionLabel={(option) =>
                                    `${option.first_name} ${option.last_name}`
                                }
                                getOptionValue={(type) => type.id}
                                value={pC}
                            />
                            </div>
                        </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Information</label>
                            <textarea value={project.bio} class="form-control" placeholder={`About the ${team.project_title}`}
                                onChange={(e) => {
                                    let value = e.target.value
                                    setProject({...project, bio: value})
                                    setDirty(true)
                                }}
                            ></textarea>
                        </div>
                        </div>
                    </div>
                </div>}

                {!props.new &&
                    <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Name</label>
                            <input type="text" className="form-control" placeholder="Project Name" id="first_name" value={project.name}
                            onChange={(e) => {
                                let value = e.target.value
                                setProject({...project, name: value})
                                setDirty(true)
                            }}
                            disabled={props.disable}
                            />
                        </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                            <label htmlFor="profile_image">{`${team.project_title} Cover Image`}</label>
                                <div id="profile_image" className="d-flex align-items-center">
                                    <button onClick={handleClick} className="btn btn-primary">
                                    {fileUploading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                        Upload Image
                                    </button>
                                </div>
                                <div>
                                    <small className="text-muted">Optimal Banner Photo Size: 1200px X 421px</small>
                                </div>
                                <input
                                    type="file"
                                    ref={hiddenFileInput}
                                    style={{ display: "none" }}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        {projectManager && <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Manager</label>
                            <input type="text" className="form-control" placeholder="Project Name" id="first_name"
                            value={`${projectManager.first_name} ${projectManager.last_name}`} disabled
                            />
                        </div>}

                        {coordinator && <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Coordinator</label>
                            <input type="text" className="form-control" placeholder="Project Name" id="first_name"
                            value={`${coordinator.first_name} ${coordinator.last_name}`} disabled
                            />
                        </div>}

                        {!projectManager &&
                            <div class="form-group">
                            <label htmlFor="manager_role">Select {team.project_title} Manager</label>
                            <div className="input-group" id="manager_role">
                            <Select
                                className="form-control select-beneficiaries"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => {
                                    setSelectedPM(type);
                                }}
                                options={projectManagers}
                                getOptionLabel={(option) =>
                                    `${option.first_name} ${option.last_name}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedPM}
                            />
                            </div>
                        </div>
                        }

                        {!coordinator &&
                            <div class="form-group">
                                <label htmlFor="manager_role">Select {team.project_title} Coodinator</label>
                                <div className="input-group" id="manager_role">
                                <Select
                                    className="form-control select-beneficiaries"
                                    classNamePrefix="select-beneficiaries"
                                    onChange={(type) => setPC(type)}
                                    options={projectCoordinators}
                                    getOptionLabel={(option) =>
                                        `${option.first_name} ${option.last_name}`
                                    }
                                    getOptionValue={(type) => type.id}
                                    value={pC}
                                />
                                </div>
                            </div>
                        }
                        </div>

                        <div className="col-md-6">
                            
                        <div class="form-group" style={{ paddingBottom: '5px' }}>
                            <label>Post From {team.donor_title}</label>
                            <div className="form-check">
                            <label className="form-check-label">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    checked={project.disable_public_donor_post}
                                    onChange={(e) => setProject({...project, disable_public_donor_post: e.target.checked})}
                                />
                                <span className="form-check-sign">Disable public post from {team.donor_title.toLowerCase()}</span>
                            </label>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="first_name">{team.project_title} Information</label>
                            <textarea value={project.bio} class="form-control" placeholder={`About the ${team.project_title}`} disabled={props.disable}
                                onChange={(e) => {
                                    let value = e.target.value
                                    setProject({...project, bio: value})
                                    setDirty(true)
                                }}
                            ></textarea>
                        </div>
                        </div>
                    </div>
                    {project.custom_field_values.length > 0 &&
                        <>
                            {project.custom_field_values.map(field => (
                                <>
                                {(field.visible || props.user !== 'manager' || props.user !== 'assistant_manager') &&
                                <div className="row" key={field.name}>
                                    <div className="col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="first_name">{field.name}</label>
                                        {(field.value_type == 'text' || field.value_type == 'link') &&
                                        <input type="text" className="form-control" placeholder={field.name} id="first_name"
                                        value={`${field.value}`} disabled={(!field.editable || props.disable) && (props.user !== 'manager' || props.user !== 'assistant_manager')}
                                        onChange={(e) => handleInputChange(field, e.target.value)}
                                        />}

                                        {field.value_type == 'long_text' &&
                                        <textarea className="form-control" placeholder={field.name} id="first_name"
                                        value={`${field.value}`} disabled={(!field.editable || props.disable) && (props.user !== 'manager' || props.user !== 'assistant_manager')}
                                        onChange={(e) => handleInputChange(field, e.target.value)}
                                        > </textarea>}

                                        {field.value_type == 'date' && field.editable && !props.disable &&
                                            <Flatpickr className="form-control"
                                            value={field.value}
                                            onChange={(date, dateStr) => {
                                                handleInputChange(field, dateStr)
                                            }}
                                          />
                                        }

                                        {field.value_type == 'date' && (!field.editable || props.disable) && (props.user !== 'manager' || props.user !== 'assistant_manager') &&
                                            <Flatpickr className="form-control"
                                            value={field.value}
                                            onChange={(date, dateStr) => {
                                                handleInputChange(field, dateStr)
                                            }}
                                            disabled
                                          />
                                        }
                                        {field.value_type == 'select' &&
                                            <select value={field.value} onChange={(event) => handleInputChange(field, event.target.value)} className='form-control' >
                                                <option></option>
                                                {field.select_options && field.select_options.map(option => (
                                                    <option value={option} key={option}>{ option }</option>
                                                ))}
                                            </select>
                                        }

                                        {field.value_type == 'dynamic' &&
                                            <div className="input-group">
                                                <input 
                                                    className="form-control" 
                                                    placeholder="Read only, click edit button to edit and create new values"
                                                    type="text"
                                                    value={field.value}
                                                    disabled
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-light btn-border" type="button" onClick={() => editModal(field)}>Edit</button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    </div>
                                </div>}
                                </>
                            ))}
                        </>
                    }
                </div>
                }
            </div>
            </div>

            {openModal && <DynamicFieldModal close={(values) => closeEditModal(values)} field_values={editing} />}
        </div>
    </div>
  )
}

export default ProjectForm
